class FeaturedCollectionComponent extends HTMLElement {
  connectedCallback() {
    if (typeof Swiper === 'undefined') return;

    new Swiper(this.querySelector('.featured-collection__swiper'), {
      slidesPerView:  parseInt(this.dataset.slidesMobile, 10)  || 2,
      spaceBetween:   16,
      watchOverflow:  true,
      observer:       true,
      observeParents: true,
      breakpoints: {
        750: {
          slidesPerView: parseInt(this.dataset.slidesDesktop, 10) || 4,
          spaceBetween:  16
        }
      },
      scrollbar: {
        el:        this.querySelector('.featured-collection__scrollbar'),
        draggable: true,
        hide:      false
      }
    });
  }
}

customElements.define('featured-collection-component', FeaturedCollectionComponent);
